var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriverGuardImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.689209,
    y: 0.689209,
    width: 46.6216,
    height: 46.6216,
    rx: 23.3108,
    fill: "#DADEE3",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4241 21.463C30.2147 20.6329 27.4682 20.141 24.492 20.141C21.5157 20.141 18.7692 20.6329 16.5598 21.463",
    stroke: "#757575",
    strokeWidth: 1.32202,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8426 21.4647L16.8782 19.5973C16.113 18.1156 15.7304 17.3748 15.9713 16.72C16.2123 16.0652 16.9538 15.8308 18.4367 15.362L23.686 13.7025C24.0443 13.5892 24.2236 13.5325 24.4073 13.5325C24.5912 13.5325 24.7705 13.5892 25.1288 13.7025L30.7315 15.4737C32.0674 15.896 32.7353 16.1071 32.9899 16.6999C33.2447 17.2927 32.971 17.9991 32.4238 19.412L31.6288 21.4647",
    stroke: "#757575",
    strokeWidth: 1.32202,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8801 21.4637V23.7444C17.8801 26.1151 19.0984 28.312 21.0894 29.5317L21.7695 29.9484C23.4441 30.9743 25.5364 30.9743 27.211 29.9484L27.8912 29.5317C29.8821 28.312 31.1004 26.1151 31.1004 23.7444V21.4637",
    stroke: "#757575",
    strokeWidth: 1.32202,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4602 29.3971L29.7823 33.3631M29.7823 33.3631L27.9727 34.9435C26.315 36.3912 25.4862 37.115 24.4942 37.115C23.5021 37.115 22.6733 36.3912 21.0157 34.9435L19.2061 33.3631M29.7823 33.3631L32.0748 34.1273C33.3943 34.5671 34.054 34.7871 34.6396 35.127C35.213 35.4597 35.733 35.8768 36.1822 36.3643C36.6411 36.8623 37.7144 38.6512 37.7144 39.9733M19.2061 33.3631L20.5281 29.3971M19.2061 33.3631L16.9135 34.1273C15.594 34.5671 14.9343 34.7871 14.3486 35.127C13.7754 35.4597 13.2554 35.8768 12.8062 36.3643C12.3473 36.8623 11.2739 38.6512 11.2739 39.9733",
    stroke: "#757575",
    strokeWidth: 1.32202,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverGuardImg);
export default __webpack_public_path__ + "static/media/driver-guard-img.22138a385c0d154c871f83ac26b907bd.svg";
export { ForwardRef as ReactComponent };